<div class="modal-header" *ngIf="!hideName">
  <h3>{{question?.Student.FirstName}} {{question?.Student.LastName}}</h3>
</div>
<div *ngIf="hideName" class="modal-header cursor" [tooltip]="'STUDENT_QUESTION_ATTEMPT_CONTENT.NAME_HIDDEN_FOR_PRIVACY_CLICK' | translate" (click)="hideName = false">
  <h3>
    <fa-icon [icon]="['fas','eye-slash']"></fa-icon>&nbsp;{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.NAME_HIDDEN' | translate }}
  </h3>
</div>

<div class="modal-body ModalPortfolioFeedback">
  <kh-teacher-question-flex *ngIf="question" [question]="question" [answerType]="question!.AnswerType" [manipulativeType]="question!.ManipulativeType" [questionChoices]="question!.QuestionChoices" questionTitle="{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.QUESTION' | translate }}">
    <ng-template #afterQuestionTextLayout>
      <div class="question-text-additional-info">
        <kh-img path="teacher-tip-icon.png" class="teacher-tip-icon" *ngIf="question!.TeacherTip && !question!.ShowTeacherTip" (click)="question!.ShowTeacherTip = true" [tooltip]="'STUDENT_QUESTION_ATTEMPT_CONTENT.VIEW_TEACHER_TIP' | translate"></kh-img>
      </div>

      <div class="alert alert-info teacher-tip-container RenderMath animate-show" *ngIf="question!.ShowTeacherTip">
        <kh-img path="teacher-tip-icon.png"></kh-img>
        <div class="teacher-tip-label">{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.TEACHER_TIP' | translate }}</div>
        <br>
        <span [innerHTML]="question!.TeacherTip | unsafeHtml"></span>
        <fa-icon [icon]="['fas', 'times']" class="teacher-tip-close" (click)="question!.ShowTeacherTip = false"></fa-icon>
      </div>
    </ng-template>

    <ng-template #answersTitleLayout>
      <kh-tq-answers-header [answerType]="question!.AnswerType" [manipulativeType]="question!.ManipulativeType" [showFullList]="true"></kh-tq-answers-header>
    </ng-template>

    <ng-template #choiceRowLayout let-choice>
      <div class="TeacherPreviewAnswerRow d-inline-block" *ngIf="!canHideChoice(choice)">
        <div class="gameplayQuestionText">
          <kh-tq-answer-content [choice]="choice" [answerType]="question!.AnswerType" [manipulativeType]="question!.ManipulativeType"></kh-tq-answer-content>
        </div>
        <div class="questionTableSelection float-right mt-1">
          <fa-icon class="answerGlyph" [icon]="['fas', choice.IsCorrect ? 'check' : 'times']" [class.glyphicon-ok]="choice.IsCorrect" [class.glyphicon-remove]="!choice.IsCorrect" [class.selected]="choice.IsFirstSelection || choice.IsSecondSelection" [class.mr-2]="!choice.IsFirstSelection" *ngIf="!canHideChoiceSideIcon(choice)"></fa-icon>
          <!-- First attempt chosen -->
          <div *ngIf="choice.IsFirstSelection" class="studentChoiceLabel">
            <ng-container *ngIf="isSingleChoice">{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.SELECTED' | translate }}</ng-container>
            <ng-container *ngIf="!isSingleChoice" class="studentChoiceLabel">{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.1ST_CHOICE' | translate }}</ng-container>
          </div>
          <!-- Second attempt chosen -->
          <div *ngIf="choice.IsSecondSelection" class="studentChoiceLabel">{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.2ND_CHOICE' | translate }}</div>
        </div>
      </div>
    </ng-template>
  </kh-teacher-question-flex>

  <div *ngIf="question?.SolutionFileId || question?.Explanation" class="TeacherDisplaySolutionBelowFlex">
    <kh-solution-display [solution]="question" layoutClass="blend" [hideFeedback]="true" [hideExtras]="hideExtras()" [hideActions]="hideActions" [showStudentName]="false" [isDemo]="isDemo" [tinymceFolder]="imagePath"></kh-solution-display>

    <div class="center" *ngIf="question!.RubricLink">
      <a target="_blank" [href]="question!.RubricLink">
        <fa-icon [icon]="['fas', 'external-link-alt']"></fa-icon>&nbsp;{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.TEACHER_RESOURCE' | translate }}
      </a>
      <br><br>
    </div>
  </div>
</div>

<div class="modal-footer justify-content-end" *ngIf="isModal">
  <button type="button" class="btn btn-primary" (click)="closeModal()">{{ 'STUDENT_QUESTION_ATTEMPT_CONTENT.CLOSE' | translate }}</button>
</div>
